import { m } from 'framer-motion';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  custom: number;
}

export const AnimationDirection = {
  backward: -1,
  forward: 1,
} as const;

export type AnimationDirectionType = (typeof AnimationDirection)[keyof typeof AnimationDirection];

const variants = {
  center: {
    x: 0,
  },
  enter: (direction: number) => {
    return {
      x: direction === AnimationDirection.forward ? '100%' : '-100%',
    };
  },
  exit: (direction: number) => {
    return {
      x: direction === AnimationDirection.backward ? '100%' : '-100%',
    };
  },
};
export default function AnimatedLayout({ children, custom }: Props) {
  return (
    <m.div
      animate='center'
      className='grow flex flex-col absolute inset-0'
      custom={custom}
      exit='exit'
      initial='enter'
      transition={{
        x: { duration: 0.3, type: 'ease-in-out' },
      }}
      variants={variants}
    >
      {children}
    </m.div>
  );
}
